import { FC, SVGProps } from "react";

import ChevronRight from "@/atoms/icon/icons/chevron_left.svg";

import { Icon } from "../icon/Icon";

export interface LinkWithIconProps {
  text: string;
  icon?: FC<SVGProps<SVGSVGElement>>;
  iconPosition?: "left" | "right";
  iconSize?:
    | "x4small"
    | "x3small"
    | "x2small"
    | "xsmall"
    | "small"
    | "medium"
    | "large"
    | "xlarge"
    | "x2large"
    | "x3large";
  onClick: () => void;
  className?: string;
}

export const LinkWithIcon: FC<LinkWithIconProps> = ({
  text,
  icon = ChevronRight,
  iconPosition = "right",
  iconSize = "xsmall",
  onClick,
  className = "",
}) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center justify-center gap-2 font-sans text-base font-medium leading-[18px] text-black opacity-80 ${className}`}
    >
      {icon && iconPosition === "left" && (
        <Icon svg={icon} size={iconSize} color="currentColor" />
      )}
      {text}
      {icon && iconPosition === "right" && (
        <div className="rotate-180">
          <Icon svg={icon} size={iconSize} color="currentColor" />
        </div>
      )}
    </button>
  );
};
